import { render, staticRenderFns } from "./EditDetails.vue?vue&type=template&id=34f90dd0&scoped=true&"
import script from "./EditDetails.vue?vue&type=script&lang=js&"
export * from "./EditDetails.vue?vue&type=script&lang=js&"
import style0 from "./Editdetails.css?vue&type=style&index=0&id=34f90dd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f90dd0",
  null
  
)

export default component.exports